// extracted by mini-css-extract-plugin
module.exports = {"container":"become-an-affiliate-main_container__tmYJH","hero":"become-an-affiliate-main_hero____85R","card":"become-an-affiliate-main_card__W2sfw"};